import React from "react";
import { Form, Input, InputNumber, Select, Switch, DatePicker, TimePicker } from "antd";

const { Option } = Select;

// TSK-2934: renders one Form.Item per configured payment-data field
// (paymentMethod.paymentDataFields from getTillData), sorted by sequence
// and filtered to active fields. Must be rendered inside an antd <Form>.
const renderControl = (field) => {
  switch (field.fieldType) {
    case "NUM":
      return <InputNumber style={{ width: "100%" }} size="large" placeholder={field.fieldName} maxLength={field.fieldLength || undefined} />;
    case "LST":
      // Backend does not yet return listReference values for LST fields
      // (list_reference column was dropped from fin_paymentmethod_data_field).
      // Options render empty until that support is added server-side.
      return (
        <Select size="large" placeholder={field.fieldName} getPopupContainer={(triggerNode) => triggerNode.parentNode}>
          {(field.listReference?.values || []).map((opt) => (
            <Option key={opt.value} value={opt.value}>
              {opt.name}
            </Option>
          ))}
        </Select>
      );
    case "YN":
      return <Switch />;
    case "DAT":
      return <DatePicker size="large" style={{ width: "100%" }} format="YYYY-MM-DD" />;
    case "TIM":
      return <TimePicker size="large" style={{ width: "100%" }} format="HH:mm:ss" />;
    case "DTM":
      return <DatePicker size="large" style={{ width: "100%" }} showTime format="YYYY-MM-DD HH:mm:ss" />;
    case "STR":
    default:
      return <Input size="large" placeholder={field.fieldName} maxLength={field.fieldLength || undefined} />;
  }
};

// BUG-2372: field_key is nullable in fin_paymentmethod_data_field (GPR's NEFT fields
// were configured without one), and a null Form.Item name silently discards the
// entered value. Fall back to the row id for the form binding and to the field
// name for the metaData key sent with the order.
export const getPaymentDataFormName = (field) => field.fieldKey || field.finPaymentmethodDataFieldId || field.fieldName;
export const getPaymentDataMetaKey = (field) => field.fieldKey || field.fieldName;

const PaymentDataForm = ({ fields }) => {
  // Blank sequence sorts last, matching getTillData's ORDER BY sequence NULLS LAST.
  const seq = (f) => (f.sequence === null || f.sequence === undefined ? Infinity : Number(f.sequence));
  const activeFields = (fields || []).filter((f) => f.isactive === "Y" || f.isactive === true).sort((a, b) => seq(a) - seq(b));

  return (
    <>
      {activeFields.map((field) => (
        <Form.Item
          key={getPaymentDataFormName(field)}
          name={getPaymentDataFormName(field)}
          valuePropName={field.fieldType === "YN" ? "checked" : "value"}
          label={
            <span style={{ color: "#000", fontSize: "1.2vw", fontWeight: "500" }}>
              {field.fieldName}
              {field.dataCapture === "MAN" && <span style={{ color: "red" }}> *</span>}
            </span>
          }
          rules={[
            {
              required: field.dataCapture === "MAN",
              message: `Please enter ${field.fieldName}`,
            },
          ]}
          style={{ marginBottom: "10px" }}
        >
          {renderControl(field)}
        </Form.Item>
      ))}
    </>
  );
};

export default PaymentDataForm;
